import { render, staticRenderFns } from "./PhoneDial.vue?vue&type=template&id=5e0038ae"
import script from "./PhoneDial.vue?vue&type=script&lang=js"
export * from "./PhoneDial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports